import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip'; 
import { ConferenceFormComponent } from './conference-form.component';
import { ConferenceFormRoutingModule } from './conference-form-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { ChipModule } from 'primeng/chip';
import { AppPanelComponent } from "../../shared/components/app-panel/app-panel.component";
import { LanguageButtonComponent } from '../../shared/components/language-button/language-button.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { StepsModule } from 'primeng/steps';
import { InputOtpModule} from 'primeng/inputotp';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { InputNumberModule } from 'primeng/inputnumber';
import { EkoDarkModeToggleComponent } from '@ekowitryna/ui';
import { SafeHtmlPipe } from '../../shared/pipes/safe-html.pipe';

@NgModule({
  declarations: [
    ConferenceFormComponent,
    
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    ButtonModule,
    TooltipModule,
    ConferenceFormRoutingModule,
    TranslateModule,
    SharedModule,
    ChipModule,
    AppPanelComponent,
    LanguageButtonComponent,
    ProgressSpinnerModule,
    CheckboxModule,
    MultiSelectModule,
    StepsModule,
    InputOtpModule,
    InputNumberModule,
    ZXingScannerModule,
    EkoDarkModeToggleComponent,
    SafeHtmlPipe
  ] 
})
export class ConferenceFormModule { }
